<template>
  <div class="demand">
    <div class="searchPart">
      <el-input v-model="demandName" placeholder="需求名称"></el-input>
      <el-select v-model="typeValue" placeholder="需求类型">
        <!--<el-option label="全部" value=""> </el-option>-->
        <el-option label="设计需求" value="DESIGN"> </el-option>
        <el-option label="建模需求" value="MODEL"> </el-option>
      </el-select>
      <el-date-picker
        v-model="demandNumberTime"
        value-format="yyyy-MM-dd"
        type="date"
        placeholder="期望交期"
      >
      </el-date-picker>
      <el-select v-model="demandTypeValue" placeholder="状态">
        <el-option label="草稿" value="DRAFT"> </el-option>
        <el-option label="待审核" value="AUDIT"> </el-option>
        <el-option label="审核通过" value="PASS"> </el-option>
        <el-option label="审核拒绝" value="REJECT"> </el-option>
      </el-select>
      <el-button class="searchBtn" @click="search">搜索</el-button>
      <el-button type="text" class="resetBtn" @click="reset">
        <i class="iconfont icon-qingchushujuku"></i>
        <span>清除条件</span>
      </el-button>
    </div>
    <div class="tablePart">
      <div class="tableTool">
        <div class="toolLeft">
          <span
            >已选： <span class="num">{{ demandSelection.length }}</span></span
          >
          <el-button
            type="primary"
            plain
            size="small"
            @click="publishSubmit('')"
            >批量发布</el-button
          >
        </div>
        <div class="toolRight">
            <el-button type="primary" size="small" @click="addDemand()"><i
                class="el-icon-circle-plus-outline"></i>添加
            </el-button>
        </div>
      </div>
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        @selection-change="handleSelectionChange"
        class="tableContent"
      >
        <el-table-column
          type="selection"
          header-align="center"
          align="center"
          width="55"
        >
        </el-table-column>
        <el-table-column
          prop="demandName"
          label="需求名称"
          header-align="center"
          align="center"
          show-overflow-tooltip
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="type"
          label="需求类型"
          header-align="center"
          align="center"
          show-overflow-tooltip
          width="200"
        >
            <template slot-scope="scope">
                {{scope.row.type}}/{{scope.row.demandClassName}}
            </template>
        </el-table-column>
        <el-table-column
          prop="demandMoney"
          label="预算"
          header-align="center"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="deadline"
          label="报价截止日期"
          header-align="center"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
          <el-table-column
              prop="demandHandTime"
              label="期望交期"
              header-align="center"
              align="center"
              width="110"
          >
          </el-table-column>
        <el-table-column
          prop="demandSendTime"
          label="发布时间"
          header-align="center"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="提交时间"
          header-align="center"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="state"
          label="状态"
          header-align="center"
          align="center"
          width="110"
        >
        </el-table-column>
          <!--<el-table-column
              prop="reason"
              label="驳回原因"
              header-align="center"
              align="center"
              width="110"
          >
          </el-table-column>-->

        <el-table-column
          label="操作"
          header-align="center"
          align="center"
          width="230"
        >
          <template slot-scope="scope">
              <el-button
                  type="text"
                  size="small"
                  v-if="scope.row.status === 'DRAFT' || scope.row.status === 'REJECT'"
                  @click="updateDemand(scope.row)"
              >编辑</el-button
              >
            <el-button
              type="text"
              size="small"
              v-if="scope.row.status === 'DRAFT' || scope.row.status === 'REJECT'"
              @click="publishSubmit(scope.row,scope.row.uuid)"
              >发布</el-button
            >
              <el-button
                  type="text"
                  size="small"
                  v-if="scope.row.status !== 'DRAFT'"
                  @click="toDialog(scope.row)"
              >需求详情</el-button
              >
              <el-button
                  type="text"
                  size="small"
                  v-if="scope.row.winnerUuid != null && scope.row.winnerUuid != ''"
                  @click="designOrderDetail(scope.row.uuid,'deg')"
              >查看订单</el-button
              >
              <el-button
                  type="text"
                  size="small"
                  v-if="scope.row.status === 'DRAFT' || scope.row.status === 'AUDIT' || scope.row.status === 'CANCEL' || scope.row.status === 'REJECT' "
                  @click="deleteDemandInfo(scope.row.uuid)"
              >删除</el-button
              >
              <!--<el-button
                  type="text"
                  size="small"
                  v-if="scope.row.status === 'DRAFT'"
                  @click="cancelDemand(scope.row.uuid)"
              >取消</el-button
              >-->
            <el-button
              type="text"
              size="small"
              v-if="
                scope.row.status === 'PASS' && scope.row.winnerUuid === null
              "
              @click="confirmDesigner(scope.row)"
              >确认设计师</el-button
            >
            <!--<el-button
              type="text"
              size="small"
              v-if="scope.row.status === 'REJECT'"
              @click="updateDemand(scope.row)"
              >重新编辑</el-button
            >-->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="handleCurrentChange"
        @prev-click="handleCurrentChange"
        @next-click="handleCurrentChange"
        layout="total,prev, pager, next,jumper"
        :current-page="current"
        :page-size="pageSize"
        :total="total"
        class="pagination"
      >
      </el-pagination>
    </div>
    <!--查看弹出框-->
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="800px"
    >
      <div class="dialogBox">
        <div class="details">
          <div class="detailsItem">
            <h3>需求信息</h3>
            <div class="itemContent">
              <div class="one-row itemFlex">
                <div class="label">需求名称:</div>
                <!-- <input type="text" v-text="demand.demandName" > -->
                <div class="name" v-text="demand.demandName">某某设计需求</div>
              </div>
              <div class="two-row itemFlex">
                <div class="label">需求类型:</div>
                <div class="name" v-text="demand.demandTypeCn">
                  设计需求--工艺设计
                </div>
              </div>
              <div class="two-row itemFlex">
                <div class="label">预算金额:</div>

                <div class="name" v-text="demand.prePrice">100 - 1000 元</div>
              </div>
              <div class="two-row itemFlex">
                <div class="label">报价截止日期:</div>
                <div class="name" v-text="demand.deadline">2021-10-11</div>
              </div>
              <div class="two-row itemFlex">
                <div class="label">期望交期:</div>
                <div class="name" v-text="demand.expectedDeliveryTime">
                  2021-10-21
                </div>
              </div>
              <div class="two-row itemFlex" v-if="demand.demandType === 'MODEL'">
                <div class="label">尺寸规格:</div>
                <div class="name">
                 {{demand.specificationsStart }}-{{ demand.specificationsEnd}}cm
                </div>
              </div>
                <div class="one-row itemFlex">
                    <div class="label">SEO关键字:</div>
                    <!-- <input type="text" v-text="demand.demandName" > -->
                    <div class="name" v-text="demand.metaKeywords"></div>
                </div>
                <div class="one-row itemFlex">
                    <div class="label">SEO描述:</div>
                    <!-- <input type="text" v-text="demand.demandName" > -->
                    <div class="name" v-text="demand.metaDescription"></div>
                </div>
            </div>
          </div>
          <div class="detailsItem">
            <h3>需求详情</h3>
            <div class="itemContent">
              <div class="-rtwoow itemFlex">
                <div class="label">交付文件类型:</div>
                <div class="name" v-text="demand.fileType">BMP、JPG</div>
              </div>
              <div class="two-row itemFlex">
                <div class="label">上传文件:</div>
                <!-- <div class="name" v-show="title == '审核'"> -->
                  <div class="name">
                  <a
                    v-for="(items, index) in demand.demandAttachments"
                    :key="index"
                    :href="items.fileUrl"
                    :download="items.fileName"
                    >{{ items.fileName }}</a
                  >
                </div>
                <!-- <div class="name" v-show="title == '查看'">
                  <a
                    v-for="(items, index) in demand.demandAttachments"
                    :key="index"
                    :href="items.fileUrl"
                    :download="items.fileName"
                    >{{ items.fileName }}</a
                  >
                </div> -->
              </div>
              <div class="two-row itemFlex">
                <div class="label">交易方式:</div>
                <div class="name">线上交易</div>
              </div>
              <div class="two-row itemFlex" style="width:100%">

                <div class="label">需求描述:</div>
                <div >
                    <div class="name" v-text="demand.demandDes">这里是需求描述</div>
                   <div class="name nameimg vHtmlMess" v-html="demand.remark">这里是需求详情</div>
                </div>


              </div>
              <!-- <div class="two-row">
                                <div class="label">备注:</div>
                                <div class="name" v-text="demand.remark">这里是备注</div>
                            </div> -->


            </div>
          </div>
        </div>
        <div class="audit">
          <h3>审核结果</h3>
          <div class="auditContent">
            <el-tag type="success" effect="dark" v-if="demand.status == 'PASS'"
              >审核已通过</el-tag
            >
            <el-tag type="warn" effect="dark" v-if="demand.status == 'AUDIT'"
              >审核进行中</el-tag
            >
            <el-tag type="danger" effect="dark" v-if="demand.status == 'REJECT'"
              >审核已驳回</el-tag
            >
            <div class="cause" v-if="demand.status == 'REJECT'">
              <div class="causeTitle">驳回原因：</div>
              <div class="causeContent" v-text="demand.reason">
                撒旦咯技术的案件卡刷点卡大家开始的阿萨的金卡多久啊口水都快就卡死的卡就卡死的卡就卡死的卡
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <!--编辑弹出框-->
    <el-dialog
      :title="title1"
      :visible.sync="dialogVisible1"
      :close-on-click-modal="false"
      width="800px"
    >
      <div class="releaseBox">
        <div class="releaseBoxTop">
          <h4>需求内容</h4>
          <div class="releaseBoxTopInput flex">
            <p class="releaseBoxbotInputP">需求类型：</p>
            <button
              :class="
                releaseIndexCopy == index
                  ? 'releaseBut'
                  : '' || items.code == editForm.demandType
                  ? 'releaseBut'
                  : ''
              "
              v-for="(items, index) in releaseButton"
              :key="index"
              @click="designRelease(index)"
            >
              {{ items.button }}
            </button>
          </div>
          <div class="releaseBoxTopInput flex">
            <p class="releaseBoxbotInputP">需求名称：</p>
            <input
              type="text"
              style="width: 350px"
              v-model="editForm.demandName"
            />
          </div>
          <div class="releaseBoxTopInput flex">
            <p class="releaseBoxbotInputP">需求预算：</p>
            <!-- <el-radio-group v-model="editForm.priceType" @change="agreeChange">
                          <el-radio label="FIXED">一口价</el-radio>
                          <el-radio label="RANGE">预算区间</el-radio>
                          <el-radio label="NONE">无项目预算</el-radio>
                        </el-radio-group> -->
            <div class="">
              <input
                type="number"
                class="input2"
                placeholder="输入最低预算"
                v-model="editForm.lowPreAmount"
              />
              -
              <input
                type="number"
                class=""
                placeholder="输入最高预算"
                v-model="editForm.highPreAmount"
              />
              元
            </div>
          </div>

          <!-- <div class="releaseBoxTopInput" v-show="priceShow2">
                      <input
                        type="number"
                        class="input2"
                        placeholder="输入预算"
                        v-model="editForm.lowPreAmount"
                      />
                      元
                    </div> -->

          <div class="releaseBoxTopInput flex">
            <p class="releaseBoxbotInputP">报名截止日期：</p>
            <el-date-picker
              :clearable="false"
              v-model="editForm.deadline"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            >
            </el-date-picker>
          </div>

          <div class="releaseBoxTopInput flex">
            <p class="releaseBoxbotInputP">期望交期：</p>
            <el-date-picker
              :clearable="false"
              v-model="editForm.expectedDeliveryTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            >
            </el-date-picker>
          </div>
        </div>
        <div class="releaseBoxTop">
          <h4>需求详情</h4>
          <!-- <div class="releaseBoxTopInput flex">
                      <p class="releaseBoxbotInputP">需求类型</p>
                      <button
                        :class="releaseIndex == index ? 'releaseBut' : ''"
                        v-for="(items, index) in releaseButton"
                        :key="index"
                        @click="designRelease(index)"
                      >
                        {{ items.button }}
                      </button>
                    </div> -->
          <div class="releaseBoxTopInput flex">
            <p class="releaseBoxbotInputP">{{ twoNameRelease }}</p>
            <button
              :class="
                releaseIndexTwo == index
                  ? 'releaseBut'
                  : '' || items.code == editForm.demandClassId
                  ? 'releaseBut'
                  : ''
              "
              v-for="(items, index) in releaseButtonTwo[releaseIndex]"
              :key="index"
              @click="designReleaseTwo(items, index)"
            >
              {{ items.name }}
            </button>
          </div>

          <div class="releaseBoxTopInput flex" style="align-items: flex-start">
            <p class="releaseBoxbotInputP" style="padding-top: 5px">
              交付文件类型
            </p>
            <div class="flex releaseBoxTopInputBox">
              <button
                v-for="(items, index) in releaseButton2[releaseIndex]"
                :class="{ releaseBut: arrIndex.indexOf(index) > -1 }"
                :key="index"
                @click="designRelease2(index, items.button)"
                style="margin-bottom: 10px"
              >
                {{ items.button }}
              </button>
              <button
                :class="otherInput ? 'releaseBut' : ''"
                @click="designReleaseOther()"
              >
                其他
              </button>
               <input
                type="text"
                style="width: 100px"
                placeholder="输入类型"
                v-show="otherInput"
                v-model="otherType"
              />
            </div>
          </div>
          <!-- <div class="releaseBoxTopInput flex">
                      <p class="releaseBoxbotInputP">期望交付</p>
                      <input type="text" style="width: 160px" />
                    </div> -->
          <div class="releaseBoxTopInput flex" v-show="releasShow">
            <p class="releaseBoxbotInputP">尺寸规格</p>
            <input
              type="text"
              style="width: 160px; margin-right: 5px"
              v-model="editForm.specificationsStart"
            />
            -
            <input
              type="text"
              style="width: 160px; margin-left: 5px"
              v-model="editForm.specificationsEnd"
            />
            cm
          </div>
        <div class="releaseBoxTopInput flex" style="align-items: flex-start">
            <p class="releaseBoxbotInputP">需求描述</p>
            <textarea v-model="editForm.demandDes" type="text" />
        </div>
          <div class="releaseBoxTopInput flex" style="align-items: flex-start">
            <p class="releaseBoxbotInputP">需求详情</p>
            <vue-editor v-model="editForm.remark" useCustomImageHandler
                        @image-added="handleImageAdded" style="width: 100%" />
          </div>
            <div class="releaseBoxTopInput flex">
                <p class="releaseBoxbotInputP">SEO关键字：</p>
                <el-input
                    type="textarea"
                    v-model="editForm.metaKeywords"
                    maxlength="50"
                    show-word-limit
                    style="width: 350px"
                ></el-input>
            </div>
            <div class="releaseBoxTopInput flex">
                <p class="releaseBoxbotInputP">SEO描述：</p>
                <el-input
                    type="textarea"
                    v-model="editForm.metaDescription"
                    maxlength="70"
                    show-word-limit
                    style="width: 350px"
                ></el-input>
            </div>
          <!-- <div class="releaseBoxTopInput flex" style="align-items: flex-start">
                        <p class="releaseBoxbotInputP">备注</p>
                        <textarea v-model="editForm.remark" type="text" />
                    </div> -->
          <div class="releaseBoxTopInput flex" style="align-items: flex-start">
            <p class="releaseBoxbotInputP">文件上传</p>
            <el-upload
              class="upload-demo"
              action="/service-center/upload/file/single"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :on-success="handleAvatarSuccess"
              :headers="headers"
              :file-list="fileList"
            >
              <el-button size="small" class="releaseBut">上传附件</el-button>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible3">
              <img width="100%" :src="dialogImageUrl" alt="" />
            </el-dialog>
          </div>
          <div class="releaseBoxTopInput flex">
            <p class="releaseBoxbotInputP">交易方式</p>
            <button
              :class="releaseIndex3 == index ? 'releaseBut' : ''"
              v-for="(items, index) in releaseButton3"
              :key="index"
              @click="designRelease3(index)"
            >
              {{ items.button }}
            </button>
          </div>
        </div>
        <div class="releaseBoxBottom">
          <!-- <button>发布需求</button> -->
          <el-button type="text" @click="open">发布需求</el-button>
          <el-button :plain="true" @click="open2">保存需求</el-button>
          <!-- <button>保存需求</button> -->
          <el-button type="text" @click="open3">返回</el-button>
          <!-- <button>返回</button> -->
        </div>
      </div>
    </el-dialog>
    <!-- 确认设计师 -->
    <confirm-designer ref="confirmDesigner" @chooseOffser="search"></confirm-designer>
  </div>
</template>

<script>
import confirmDesigner from './confirmDesigner'
import {
    findAllDesignList,
    addDemand,
  updateDemand,
  demandListByPage,
  publishDemand,
  getDictionaryItem,
    cancelDemand,
    deleteDemandInfo,
    uploadFile,
} from "../../utils/interface";
import { mapState, mapMutations } from "vuex";

export default {
  data() {
    return {
      form: {},
      demandNumberTime: "",
      typeValue: "",
      demandName: "",
      tableData: [],
      current: 0,
      pageSize: 10,
      total: 1000,
      dialogVisible: false,
      dialogVisible1: false,
      title: "",
      title1: "",
      demandTypeValue: "",
      demandSelection: [],
      demand: {},

      editForm: {},

      priceShow1: false,
      priceShow2: false,
      headers: {
        Authorization: "Bearer " + this.$cookies.get("api_access_token"), //	可以是授权凭证用的参数值
      },
      loading: false,
      setIn: null, // 定时器
      radio: "1",
      releaseButton: [
          {
              button: "三维设计",
              code: "MODEL",
          },
        {
          button: "平面设计",
          code: "DESIGN",
        },
      ],
      releaseIndex: "0",
      releaseIndexCopy: null,
      releaseButtonTwo: [],
      releaseIndexTwo: null,
      releaseButton2: [
        [
          {
            button: "STEP",
          },
          {
            button: "STL",
          },
          {
            button: "IGES",
          },
          {
            button: "OBJ",
          },
        ],
          [
              {
                  button: "BMP",
              },
              {
                  button: "JPG",
              },
              {
                  button: "PNG",
              },
              {
                  button: "CDR",
              },
              {
                  button: "PCD",
              },
              {
                  button: "AI",
              },
              {
                  button: "RAW",
              },
              {
                  button: "WMF",
              },
          ],
      ],
      releaseIndex2: "0",

      releaseButton3: [
        {
          button: "线上支付",
          payType: "ONLINE",
        },
        // {
        //   button: "线下支付",
        // },
      ],
      releaseIndex3: "0",
      //   交期
      value1: "",
      //   文件上传
      fileList: [],
      releasShow: true,
      arrIndex: [],
      dialogImageUrl: "",
      dialogVisible3: false,
      twoNameRelease: "建模需求",
      otherInput: false,
      //   区间金额
      monyeOne: "",
      monyeTwo: "",
      //   区间尺寸
      specificationsStart: "",
      specificationsEnd: "",
      fType: [],
      otherType: "",
      agreePrice: "",
    };
  },
  components: {
    confirmDesigner
  },
  computed: {
    ...mapState({}),
  },
  created() {
    this.search();
    this.getDictionaryItem();

    // this.setIn = setInterval(() => {
    //   if (this.isTokenDoor === true) {
    //     clearInterval(this.setIn);
    //   }
    // }, 500);
  },
  methods: {
      async handleImageAdded(file, Editor, cursorLocation, resetUploader) {
          // console.log('图片上传', );
          var formData = new FormData();
          formData.append("file", file); //第一个file 后台接收的参数名
          let res = await uploadFile(formData);
          // console.log('上传成功', res);
          if (res.url) {
              Editor.insertEmbed(cursorLocation, "image", res.url);
              resetUploader();
          } else {
              alert("上传返回失败");
          }
      },
      // 订单详情
      designOrderDetail(uuid,type){
          findAllDesignList({isBuy:true, demandUuid: uuid}).then((res)=>{
              if(res && res.length>0){
                  this.$router.push({name:'designOrderDetail',params:{uuid:res[0].uuid,type: 'publish'}});
                  this.$emit('hompageLog','deg')
              }
          });


      },
    // 清除检索条件
    reset() {
      this.demandNumberTime = "";
      this.typeValue = "";
      this.demandName = "";
      this.demandTypeValue = "";
    },
    // 分页
    handleCurrentChange(val) {
      this.current = val;
      this.search();
    },
    // 复选框选中值
    handleSelectionChange(val) {
      this.demandSelection = val;
    },
    search() {
        console.log(this.form,'更新的数据')
      this.form.demandName = this.demandName;
      this.form.demandType = this.typeValue;
      this.form.status = this.demandTypeValue;
      this.form.prePrice = this.demandNumberTime;
      if (this.demandNumberTime != null) {
        this.form.expectedDeliveryTime = this.demandNumberTime;
      }
      this.form.current = this.current;
      this.form.pageSize = this.pageSize;
      demandListByPage(this.form).then((res) => {
        this.tableData = [];
        // console.log(res);
        if (res != null && res.list != null && res.list.length > 0) {
          console.log(res)
          this.total = res.total;
          res.list.forEach((item, index) => {
            let demand = {};
            demand.demandDetail = item;

            demand.uuid = item.uuid;
            demand.demandNo = item.demandNo;
            demand.demandName = item.demandName;
            demand.type = item.demandTypeCn;
            if(item.lowPreAmount != null && item.lowPreAmount != undefined){
                demand.demandMoney =
                    item.lowPreAmount + " - " + item.highPreAmount + " 元";
                demand.demandDetail.prePrice =
                    item.lowPreAmount + " - " + item.highPreAmount + " 元";
            }
            demand.demandHandTime = item.expectedDeliveryTime;
            demand.demandSendTime = item.publishTime;
            demand.createTime = item.createTime;
            demand.deadline = item.deadline;
            demand.state = item.statusCn;
            demand.status = item.status;
            demand.winnerUuid = item.winnerUuid;
            demand.winner = item.winner;
            demand.demandClassName = item.demandClassName;
            //需求类型中的设计需求
            demand.demandClassName=item.demandClassName;
            //交付文件类型
            demand.fileType=item.fileType;
            //需求描述
            demand.demandDes=item.demandDes;
            //需求详情
            demand.remark=item.remark;
            demand.reason = item.status == 'REJECT'?item.reason :"";
            this.tableData.push(demand);
            // console.log(this.tableData);
          });
        } else {
          this.total = 0;
        }
      });
    },
    // 查看
    toDialog(demand) {
      this.dialogVisible = true;
      this.demand = demand.demandDetail;
      this.title = "需求详情";
    },
      addDemand(){
          this.otherInput = false;
          this.otherType = "";
          this.dialogVisible1 = true;
          this.editForm = {

          };
          this.releasShow = true;
          this.twoNameRelease = "建模需求";
          this.editForm.demandType = "MODEL";
      },
    // 编辑
    updateDemand(demand) {
        console.log(demand.demandDetail,'编辑')
      this.otherInput = false;
      this.otherType = "";
      this.dialogVisible1 = true;
      this.editForm = demand.demandDetail;
      if (this.editForm.demandType == "DESIGN") {
        this.releaseIndex = 0;
      } else if (this.editForm.demandType == "MODEL") {
        this.releaseIndex = 1;
      }
      if (this.releaseIndex == 0) {
        this.releasShow = false;
        this.twoNameRelease = "设计需求";
        this.editForm.demandType = "DESIGN";
        this.editForm.specificationsStart = null;
        this.editForm.specificationsEnd = null;
      } else {
        this.releasShow = true;
        this.twoNameRelease = "建模需求";
        this.editForm.demandType = "MODEL";
      }
      if(this.editForm.fileType){
          this.editForm.fileTypes = this.editForm.fileType.split("、");
          if (this.editForm.fileTypes.length > 0) {
              let otherTypes = [];

              this.editForm.fileTypes.forEach((item, index) => {
                  //   this.arrIndex = [];
                  if (item == "BMP") {
                      index = 0;
                      this.arrIndex.push(index);
                  }
                  if (item == "JPG") {
                      index = 1;
                      this.arrIndex.push(index);
                  }
                  if (item == "PNG") {
                      index = 2;
                      this.arrIndex.push(index);
                  }
                  if (item == "CDR") {
                      index = 3;
                      this.arrIndex.push(index);
                  }
                  if (item == "PCD") {
                      index = 4;
                      this.arrIndex.push(index);
                  }
                  if (item == "AI") {
                      index = 5;
                      this.arrIndex.push(index);
                  }
                  if (item == "RAW") {
                      index = 6;
                      this.arrIndex.push(index);
                  }
                  if (item == "WMF") {
                      index = 7;
                      this.arrIndex.push(index);
                  }
                  if (item == "STEP") {
                      index = 0;
                      this.arrIndex.push(index);
                  }
                  if (item == "STL") {
                      index = 1;
                      this.arrIndex.push(index);
                  }
                  if (item == "IGES") {
                      index = 2;
                      this.arrIndex.push(index);
                  }
                  if (item == "OBJ") {
                      index = 3;
                      this.arrIndex.push(index);
                  }
                  if (
                      item != "BMP" &&
                      item != "JPG" &&
                      item != "PNG" &&
                      item != "CDR" &&
                      item != "PCD" &&
                      item != "AI" &&
                      item != "RAW" &&
                      item != "WMF" &&
                      item != "STEP" &&
                      item != "STL" &&
                      item != "IGES" &&
                      item != "OBJ"
                  ) {
                      otherTypes.push(item);
                      this.editForm.fileTypes.splice(index, 1);
                  }
              });
              this.fType = this.editForm.fileTypes;
              if (otherTypes.length != 0) {
                  this.otherInput = true;
                  this.otherType = otherTypes;
              }
          }
      }
        if(this.editForm.demandAttachments){
            this.fileList = this.editForm.demandAttachments

            this.fileList.forEach((files)=>{
                files.name = files.fileName
                files.url = files.fileUrl

            })
        }
      this.title = "编辑";
    },
      // 取消需求
      cancelDemand(uuid){
          this.$confirm("确定取消所选需求?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
          })
          .then(() => {
              let params = {
                  uuid:uuid,
                  status:"CANCEL"
              };
              cancelDemand(params).then((res)=>{
                  if(res.success){
                      this.$message.success("取消成功！");
                      this.search();
                  }
              });
          });
      },
    // 确定发布
    publishSubmit(row,uuid) {
     if (row.demandName=="") {
        this.$alert("请完善需求的全部内容，才可进行发布", "提示", {
          confirmButtonText: "确定",
        });
      }else if(row.demandClassName==''){
          this.$alert("请完善需求的全部内容，才可进行发布", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }else if(row.prePrice==''){
         this.$alert("请完善需求的全部内容，才可进行发布", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }else if(row.deadline==''){
         this.$alert("请完善需求的全部内容，才可进行发布", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }else if(row.expectedDeliveryTime==''){
        this.$alert("请完善需求的全部内容，才可进行发布", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }else if(row.fileType==''){
        this.$alert("请完善需求的全部内容，才可进行发布", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }else if(row.demandDes==''){
        this.$alert("请完善需求的全部内容，才可进行发布", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }else if(row.remark==''){
        this.$alert("请完善需求的全部内容，才可进行发布", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }else{
         if (uuid != "" && uuid != null) {
        this.demandSelection = [];
        this.demandSelection.push(uuid);
      } else if (this.demandSelection.length > 0) {
        let ids = [];
        console.log(this.demandSelection)
        this.demandSelection.forEach((item, index) => {
          ids.push(item.uuid);

        });


         for(let item=0;item<this.demandSelection.length;item++){
            if(this.demandSelection[item].demandName==''){
                             this.$alert("请完善需求的全部内容，才可进行发布", "提示", {
                                confirmButtonText: "确定",
                                });
                                return;
                        }else if(this.demandSelection[item].demandClassName==''){
                             this.$alert("请完善需求的全部内容，才可进行发布", "提示", {
                                confirmButtonText: "确定",
                                });
                                return;
                        }else if(this.demandSelection[item].prePrice==''){
                             this.$alert("请完善需求的全部内容，才可进行发布", "提示", {
                                confirmButtonText: "确定",
                                });
                                return;
                        }else if(this.demandSelection[item].deadline==''){
                             this.$alert("请完善需求的全部内容，才可进行发布", "提示", {
                                confirmButtonText: "确定",
                                });
                                return;
                        }else if(this.demandSelection[item].expectedDeliveryTime==''){
                             this.$alert("请完善需求的全部内容，才可进行发布", "提示", {
                                confirmButtonText: "确定",
                                });
                                return;
                        }else if(this.demandSelection[item].fileType==''){
                             this.$alert("请完善需求的全部内容，才可进行发布", "提示", {
                                confirmButtonText: "确定",
                                });
                                return;
                        }else if(this.demandSelection[item].demandDes==''){
                             this.$alert("请完善需求的全部内容，才可进行发布", "提示", {
                                confirmButtonText: "确定",
                                });
                                return;
                        }else if(this.demandSelection[item].remark==''){
                             this.$alert("请完善需求的全部内容，才可进行发布", "提示", {
                                confirmButtonText: "确定",
                                });
                                return;
                        }
        }
         this.demandSelection = ids;
      }

      this.$confirm("确定发布所选需求吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          publishDemand(this.demandSelection).then((res) => {
            if (res && res.success) {
              this.$message.success("发布成功！");
              this.dialogVisible = false;
              this.search();
            }
          });
        })
        .catch(() => {});
      }

      // if (uuid != "" && uuid != null) {
      //   this.demandSelection = [];
      //   this.demandSelection.push(uuid);
      // } else if (this.demandSelection.length > 0) {
      //   let ids = [];
      //   this.demandSelection.forEach((item, index) => {
      //     ids.push(item.uuid);
      //   });
      //   this.demandSelection = ids;
      // }

      // this.$confirm("确定发布所选需求吗?", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning",
      // })
      //   .then(() => {
      //     publishDemand(this.demandSelection).then((res) => {
      //       if (res && res.success) {
      //         this.$message.success("发布成功！");
      //         this.dialogVisible = false;
      //         this.search();
      //       }
      //     });
      //   })
      //   .catch(() => {});
    },
      deleteDemandInfo(uuid){
          this.$confirm("确定删除所选需求吗?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
          })
          .then(() => {
              deleteDemandInfo({uuid:uuid}).then((res) => {
                  if (res && res.success) {
                      this.$message.success("删除成功！");
                      this.search();
                  }
              });
          })
          .catch(() => {});
      },

    designRelease(i) {
      this.releaseIndexCopy = i;
      this.releaseIndex = i;
      this.arrIndex = [];
      //   this.releaseIndexTwo = null;
      //   this.otherInput = false;
      if (this.releaseIndex == 0) {
          this.releasShow = true;
          this.twoNameRelease = "建模需求";
          this.editForm.demandType = "MODEL";
      } else {
          this.releasShow = false;
          this.twoNameRelease = "设计需求";
          this.editForm.demandType = "DESIGN";
          this.editForm.specificationsStart = null;
          this.editForm.specificationsEnd = null;
      }
    },
    designReleaseTwo(items, i) {
      this.releaseIndexTwo = i;
        this.editForm.demandClassId = items.code;
        this.editForm.demandClassName = items.name;
    },
    designRelease2(i, items) {
      this.releaseIndex2 = i;
      let arrIndex = this.arrIndex.indexOf(i);
      if (arrIndex > -1) {
        // 已选中,点击取消
        this.arrIndex.splice(arrIndex, 1);
        this.fType.splice(arrIndex, 1);
      } else {
        // 未选中,点击选中
        this.arrIndex.push(i);
        this.fType.push(this.releaseButton2[this.releaseIndex][i].button);
      }
    },
    // 其他
    designReleaseOther() {
      this.otherInput = !this.otherInput;
    },
    designRelease3(i) {
      this.releaseIndex3 = i;
      if (i == 0) {
        this.editForm.payType = "ONLINE";
      }
    },
    // 文件上传
    // 移除、点击 按钮 文件的信息
    handleRemove(file, fileList) {
      this.fileList = fileList
      console.log(fileList,11111)
    },
    // 预览文件
    handlePreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible3 = true;
    },
    handleAvatarSuccess(obj, fileList) {
      this.fileList.push(obj);
    },
    // 删除文件提示按钮
    beforeRemove(file, fileList) {
        console.log(file, fileList)
      // return this.$confirm(`确定移除 ${file.name}？`);
    },
    // 发布需求
    open() {
      const h = this.$createElement;
      console.log(!this.editForm.uuid)
        if (!this.editForm.uuid) {
            this.$alert("请先保存需求", "提示", {
                confirmButtonText: "确定",
            });
            return;
        }
      if (!this.editForm.demandType) {
        this.$alert("请选择需求类型", "提示", {
          confirmButtonText: "确定",
        });
          return;
      } else if (!this.editForm.demandName) {
        this.$alert("请填写需求名称", "提示", {
          confirmButtonText: "确定",
        });
        return;
      } else if (!this.editForm.lowPreAmount) {
        this.$alert("请填写预算最小值", "提示", {
          confirmButtonText: "确定",
        });
        return;
      } else if (!this.editForm.highPreAmount) {
        this.$alert("请填写预算最大值", "提示", {
          confirmButtonText: "确定",
        });
        return;
      } else if (this.editForm.lowPreAmount > this.editForm.highPreAmount) {
        this.$alert("预算最小值不可大于预算最大值", "提示", {
          confirmButtonText: "确定",
        });
        return;
      } else if (!this.editForm.expectedDeliveryTime) {
        this.$alert("请填写期望交期", "提示", {
          confirmButtonText: "确定",
        });
        return;
      } else if (!this.editForm.deadline) {
        this.$alert("请填写报名截止日期", "提示", {
          confirmButtonText: "确定",
        });
        return;
      } else if (!this.editForm.demandClassId) {
        this.$alert("请填写需求分类", "提示", {
          confirmButtonText: "确定",
        });
        return;
      } else if (this.fType.length == 0) {
        this.$alert("请填写交付文件类型", "提示", {
          confirmButtonText: "确定",
        });
        return;
      } else if (this.releasShow == true) {
        if (!this.editForm.specificationsStart) {
          this.$alert("请填写尺寸规格最小值", "提示", {
            confirmButtonText: "确定",
          });
          return;
        } else if (!this.editForm.specificationsEnd) {
          this.$alert("请填写尺寸规格最大值", "提示", {
            confirmButtonText: "确定",
          });
          return;
        } else if (
          this.editForm.specificationsStart > this.editForm.specificationsEnd
        ) {
          this.$alert("尺寸规格最小值不能大于最大值", "提示", {
            confirmButtonText: "确定",
          });
          return;
        }
      }
      if (!this.editForm.demandDes) {
        this.$alert("请填写需求详情", "提示", {
          confirmButtonText: "确定",
        });
        return;
      } else {
        this.$msgbox({
          title: "发布需求",
          message: "是否发布需求",
          showCancelButton: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = "发布中...";
              setTimeout(() => {
                done();
                setTimeout(() => {
                  instance.confirmButtonLoading = false;
                }, 300);
              }, 3000);
            } else {
              done();
            }
          },
        }).then((action) => {
          let files = [];
          for (let i = 0; i < this.fileList.length; i++) {
            files.push({
              fileUrl: this.fileList[i].url,
              fileName: this.fileList[i].name,
            });
          }
          this.editForm.demandAttachments = files;
          // console.log(this.editForm.demandAttachments);
          let fTypes = "";
          if (this.fType != null && this.fType.length > 0) {
            this.fType.forEach((item, index) => {
              fTypes += item + "、";
            });
          }
          if (this.otherType != "") {
            fTypes = fTypes + this.otherType;
          } else if (
            this.otherType == "" &&
            this.fType != null &&
            this.fType.length > 0
          ) {
            fTypes = fTypes.substring(0, fTypes.length - 1);
          }
          this.editForm.fileType = fTypes;
          this.editForm.payType = "ONLINE";
          this.editForm.status = "AUDIT";
          // console.log(this.editForm);
          updateDemand(this.editForm).then((response) => {
            this.$message({
              type: "success",
              message: "需求提交成功，请耐心等待平台审核",
            });
            this.dialogVisible1 = false;
            this.search();
          });
        });
      }
    },
    // 保存成功
    open2() {
      let files = [];
        console.log(this.fileList,'保存需求的时候查看附件列表')
      for (let i = 0; i < this.fileList.length; i++) {
        files.push({
          fileUrl: this.fileList[i].url,
          fileName: this.fileList[i].name,
        });
      }
      this.editForm.demandAttachments = files;
      let fTypes = "";
      if (this.fType != null && this.fType.length > 0) {
        this.fType.forEach((item, index) => {
          fTypes += item + "、";
        });
      }
      if (this.otherType != "") {
        fTypes = fTypes + this.otherType;
      } else if (
        this.otherType == "" &&
        this.fType != null &&
        this.fType.length > 0
      ) {
        fTypes = fTypes.substring(0, fTypes.length - 1);
      }
      this.editForm.fileType = fTypes;
      this.editForm.payType = "ONLINE";
      this.editForm.status = "DRAFT";
      console.log(this.editForm,'保存的字段附件有无值');
      // console.log(this.editForm);
        if(this.editForm.uuid == null || this.editForm.uuid == ""){
            addDemand(this.editForm).then((response) => {
                this.$message({
                    message: "保存需求成功",
                    type: "success",
                });
                this.dialogVisible = false;
                this.dialogVisible1 = false;
                this.search();
            });
        }else{
            updateDemand(this.editForm).then((response) => {
                this.$message({
                    message: "保存需求成功",
                    type: "success",
                });
                this.dialogVisible = false;
                this.dialogVisible1 = false;
                this.search();
            });
        }

    },
    //   返回
    open3() {
      // this.$confirm("此操作将清空所有内容?", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning",
      // })
      //   .then(() => {
          this.editForm = [];
          this.fType = [];
          this.arrIndex = [];
          this.otherType = "";
          // this.$message({
          //   type: "success",
          //   message: "清除成功!",
          // });
        this.dialogVisible1 = false;
          this.search();
        // })
        // .catch(() => {
        //   this.$message({
        //     type: "info",
        //     message: "已取消",
        //   });
        // });
    },
    // 获取字典值
    getDictionaryItem() {
      this.editForm.demandType = "DESIGN";
      getDictionaryItem({ groupCode: "design" }).then((res) => {
        this.releaseButtonTwo.push(res);
      });
      getDictionaryItem({ groupCode: "model" }).then((res) => {
        this.releaseButtonTwo.push(res);
      });
    },
    // 确认设计师
    confirmDesigner(mess){
      this.$refs.confirmDesigner.init(mess)
    }
  },
};
</script>

<style scoped lang="less">
.demand {
  padding: 20px;



  //审核需求详情中title的样式
/deep/.el-dialog__header{
    // border-bottom: 1px solid #ddd;
   .el-dialog__title{
    color: #000;
    font-weight: 700;
    font-size: 16px;

  }
}
.detailsItem{
  h3{
     font-weight: 700;
      font-size: 16px;
          color: #000;
          letter-spacing: 1px;

  }
  .itemContent{
    display: flex;
    flex-wrap: wrap;
    font-size: 15px;
     .one-row {
            width: 50%;
            margin-bottom: 22px;
            display: flex;
            font-size: 14px;
            .label {
              padding-right: 15px;
              min-width: 95px;
              color: rgba(0, 0, 0, 0.85);
            }
            .name {
              color: rgba(0, 0, 0, 0.65);
            }
        }
        /deep/.nameimg  img{
            width: 100%!important;
          }
       .two-row {
            width: 50%;
            margin-bottom: 22px;
            display: flex;
            font-size: 14px;
            .label {
              padding-right: 15px;
              min-width: 95px;
              color: rgba(0, 0, 0, 0.85);
            }
            .name {
              color: rgba(0, 0, 0, 0.65);
            }
          }
  }
}
.audit {
      h3 {
        font-weight: 700;
        font-size: 16px;
        color: #000;
        margin-top: 0;
        letter-spacing: 1px;
        // border-bottom: 1px solid #ddd;

      }
    .cause {
        display: flex;
        margin-top: 20px;
        .causeTitle {
            min-width: 80px;
            color: #3a8ee6;
        }
        .causeContent {
            color: #000;
        }
    }
  }
  .releaseBox {
    background: #fff;
    padding: 35px;
    padding-top: 0;
    box-sizing: border-box;
    .releaseBoxTop {
      margin-bottom: 15px;
      h4 {
        font-size: 18px;
        color: #157efa;
        margin-bottom: 18px;
      }
      .releaseBoxTopInput {
        font-size: 14px;
        color: #262626;
        align-items: center;
        margin-bottom: 20px;
        .releaseBoxTopInputBox {
          flex-wrap: wrap;
        }
        input {
          height: 30px;
          background: #f5f5f5;
          border-radius: 4px;
          border: none;
          padding-left: 8px;
          box-sizing: border-box;
        }
        .input2 {
          width: 161px;
          // margin-left: 90px;
        }
        textarea {
          width: 614px;
          height: 206px;
          background: #f5f5f5;
          opacity: 1;
          border-radius: 6px;
          border: none;
          padding: 8px;
          box-sizing: border-box;
        }
        /deep/.el-input--prefix .el-input__inner {
          width: 161px;
          height: 30px;
          background: #f5f5f5;
          border-radius: 4px;
          border: none;
          //   padding-left: 8px;
          box-sizing: border-box;
          //   margin-left: 25px;
        }
        // /deep/.el-input__prefix {
        //   right: -132px;
        //   left: 0;
        // }
        /deep/.el-input__icon {
          line-height: 30px;
        }
        .releaseBoxbotInputP {
          width: 94px;
          flex-shrink: 0;
          white-space: nowrap;
        }
        .releaseBut {
          background: #157efb;
          color: #fff;
        }
        button {
          width: 100px;
          height: 30px;
          background: #f5f5f5;
          border-radius: 4px;
          border: none;
          margin-right: 20px;
          color: #262626;
          font-size: 14px;
          cursor: pointer;
        }
      }
    }
    .releaseBoxBottom {
      font-size: 14px;
      margin: 0 auto;
      margin-top: 45px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      button {
        height: 31px;
        border-radius: 4px;
        color: #fff;
        border: none;
        cursor: pointer;
        line-height: 9px;

        &:nth-of-type(1) {
          width: 105px;
          background: linear-gradient(180deg, #4377fa 0%, #606aff 100%);
        }
        &:nth-of-type(2) {
          width: 105px;
          background: #157efb;
          margin: 0 20px;
        }
        &:nth-of-type(3) {
          width: 62px;
          background: #ebc71d;
        }
      }
    }
  }

  .searchPart {
    display: flex;
    flex-wrap: wrap;

    /deep/ .el-input {
      width: initial;
      margin-bottom: 22px;
      margin-right: 30px;
    }

    /deep/ .el-input__inner {
      width: 242px;
      height: 35px;
      min-height: 35px;
      font-size: 12px;
      color: #999999;
      background-color: #f2f4f7;
      border: 1px solid #f2f4f7;
      border-radius: 5px;

      &:hover,
      &:focus {
        background-color: #fff;
        border: 1px solid #108ee9;
      }
    }

    /deep/ .el-input__prefix {
      top: -3px;
    }

    /deep/ .el-input__suffix {
      top: 2px;
    }

    /deep/ .el-button {
      display: block;
      line-height: 35px;
      padding: 0;
      height: 35px;
    }

    .searchBtn {
      width: 82px;
      background: #3d7fff;
      border: none;
      border-radius: 15px;
      font-size: 14px;
      color: #ffffff;
      margin-bottom: 22px;
    }

    .resetBtn {
      color: #333333;
      margin-bottom: 22px;
    }
  }

  .tablePart {
    .tableTool {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;

      .toolLeft {
        font-size: 12px;
        color: rgba(0, 0, 0, 0.847);

        .num {
          color: #356fdf;
        }

        button {
          padding: 0;
          margin-left: 15px;
          width: 80px;
          height: 30px;
          background: rgba(242, 244, 247, 1);
          box-sizing: border-box;
          border: 1px solid rgba(21, 126, 251, 1);
          border-radius: 5px;
          font-size: 12px;
          color: #157efb;
          line-height: 30px;
          text-align: center;

          &:hover {
            background: #157efb;
            box-sizing: border-box;
            border: 1px solid #157efb;
            color: #fff;
          }
        }
      }

      .toolRight {
        button {
          width: 83px;
          height: 30px;
          background: rgba(21, 126, 251, 1);
          border: none;
          border-radius: 15px;
          font-size: 13px;
          color: #fff;

          i {
            padding-right: 5px;
          }

          &:hover {
            background: #61a2f0;
          }
        }
      }
    }

    .tableContent {
      min-height: 650px;

      /deep/ .el-table__header {
        tr {
          th {
            border-right: none;
          }
        }

        /deep/ .el-table__cell {
          padding: 5px 0;
          background: #f2f5fc;
        }
      }

      /deep/ .el-table__body {
        img {
          vertical-align: middle;
          width: 52px;
          height: 50px;
        }

        /deep/ .el-table__row {
          td:first-child {
            border-right: none;

            .cell {
              padding-left: 15px;
            }
          }
        }
      }
    }

    .pagination {
      margin-top: 20px;
      text-align: right;
    }
  }
}
/deep/.el-dialog__body {
  padding-top: 0;
}
.itemFlex {
  display: flex;
  // align-items: center;
  margin-bottom: 14px;
  .name {
    margin-left: 10px;
    /deep/p {
      margin: 0 !important;
    }
  }
  .label {
    flex-shrink: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/demand/demand.vue